<template>
  <v-dialog :value="isShow" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chuyển Sale gia hạn
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Chuyển sale gia hạn"
              >
                <common-select-user
                  v-model="sale"
                  :items="listSale"
                  color="primary"
                  item-text="fullName"
                  :item-value="(item) => item"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-4 w-full d-flex justify-end">
          <div class="d-flex justify-space-between" style="width:27%">
            <v-btn class="cancel-button" @click="hideModal">Hủy bỏ</v-btn>
            <v-btn class="update-button" @click.prevent="handleSubmit(saveChange)">Xác nhận</v-btn>
          </div>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex';
import * as moment from 'moment';
import { BLENDED_TAB_INDEX } from '@/modules/blended/const';
import { TYPE_CURRICULUM_OBJ } from '@/helpers/constant';
import TokenService from '../../../helpers/token';
import BlendedCareServices from '../../../services/BlendedCareRepository';

export default {
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    isValidNoSale: {
      type: Boolean,
      default: () => true,
    },
    tab: {
      type: Number,
      default: () => null,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    filterForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      sale: {},
      BLENDED_TAB_INDEX,
    };
  },
  created() {
    const dataUser = TokenService.getUser() || {};
    this.userId = _.get(dataUser, 'id', '');
  },
  computed: {
    ...mapState('student_care', ['listSale']),
    ...mapState('blended', ['dataBlendedTutor']),
  },
  methods: {
    hideModal() {
      this.$emit('close-modal-add-head-teacher', false);
      this.errorMessage = '';
      this.userId = '';
    },
    async saveChange() {
      if (this.dataBlendedTutor && this.dataBlendedTutor.length > 0) {
        const listSelectedId = [];
        this.dataBlendedTutor.forEach(
          (contact) => {
            if (contact.checkbox) {
              listSelectedId.push(contact.id);
            }
          },
        );
        if (listSelectedId.length === 0) {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Vui lòng chọn khách hàng !!!',
          });
        }

        if ((!this.sale.id || !this.sale.fullName)) {
          if (!this.isValidNoSale || this.tab === BLENDED_TAB_INDEX.EXTEND_DUO) {
            this.$swal({
              type: 'error',
              title: 'Lỗi !',
              text: 'Vui lòng chọn Sale gia hạn !!!',
            });
            return;
          }
          this.$swal({
            title: '<p style="font-size: 16px; font-weight: normal">Chuyển sale và không phân sale gia hạn</p>',
            html: '<p style="font-weight: bold; font-size: 20px">Bạn có muốn tiếp tục ?</p>',
            showCancelButton: true,
            cancelButtonText: 'Hủy',
            confirmButtonText: 'Xác nhận',
            confirmButtonColor: '#FD1F6D',
          }).then(async (result) => {
            if (result.isConfirmed) {
              await this.handleChangeSale(listSelectedId, true);
            }
          });
          return;
        }
        await this.handleChangeSale(listSelectedId, false);
      }
    },
    async handleChangeSale(listSelectedId, nosale) {
      const loading = this.$loading.show();
      let result = null;
      if (this.tab === BLENDED_TAB_INDEX.EXTEND_TUTOR || this.tab === BLENDED_TAB_INDEX.PERIODICALLY_CARE) {
        result = await BlendedCareServices.updateSale({
          ids: listSelectedId,
          userId: this.sale.id,
        });
        if (result && result.message === 'Success') {
          this.$swal({
            type: 'success',
            title: 'Thành công',
            text: nosale ? 'Chuyển sale thành công' : result.data,
          });
          Bus.$emit('reload-page-blended');
          this.hideModal();
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: result.message,
          });
        }
      } else if (this.tab === BLENDED_TAB_INDEX.EXTEND_DUO) {
        this.$swal({
          title: '<p style="font-size: 16px; font-weight: normal">Chuyển sale gia hạn tại tab Duo cũng đồng bộ sale gia hạn cho học sinh Tutor</p>',
          html: '<p style="font-weight: bold; font-size: 20px">Bạn có muốn chuyển sale gia hạn ?</p>',
          showCancelButton: true,
          cancelButtonText: 'Hủy',
          confirmButtonText: 'Xác nhận',
          confirmButtonColor: '#FD1F6D',
        }).then(async (res) => {
          if (res.isConfirmed) {
            result = await BlendedCareServices.updateSaleDuo({
              ids: listSelectedId,
              extend_sale_id: this.sale.id,
            });
            if (result && result.message === 'Success') {
              this.$swal({
                type: 'success',
                title: 'Thành công',
                text: nosale ? 'Chuyển sale thành công' : result.data,
              });
              Bus.$emit('reload-page-blended');
              this.hideModal();
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: result.message,
              });
            }
          }
        });
      }
      loading.hide();
    },
    checkTypeCs() {
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        return 'TA - CS';
      }
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        return 'CS';
      }
      return '';
    },
    formatDateCustom(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>
<style scoped>
.w-full {
  width: 100%;
}
.update-button {
  background-color: #fd1f6d !important;
  color: white;
}
.cancel-button {
  background: #BDBDBD !important;
  color: white;
}
</style>
